import React, { useState, useCallback } from 'react';
import Modal from 'react-bootstrap/Modal';
import { Input, CheckBox, Select } from '../../Components/Form/Form';
import Button from 'react-bootstrap/Button';
import Helpers from '../../Helpers/Helpers';
import { toast as toastr } from 'react-toastify';
import Controllers from '../../Api/Controllers';
import './Login.scss';

const Login = () => {
  const years = []
  const date = new Date();
  const currentYear = date.getFullYear()
  const isSigepro = /(^|\.)sigepro\.org$/i.test(window.location.hostname)
  // const isSigepro = true
  const [session, setSession] = useState({
    year: currentYear,
    username: Helpers.config.isDeveloperWeb() ? 'administrador' : '',
    password: Helpers.config.isDeveloperWeb() ? '1234' : ''
  })
  const [showChangePwd, setShowChangePwd] = useState(false)
  const [newPwd, setNewPwd] = useState('')
  const [confirmPwd, setConfirmPwd] = useState('')
  const [changing, setChanging] = useState(false)

  for (let i = 2020; i <= (currentYear+1); i++) {
    years.push(i)
  }

  const dataSubmit = useCallback(() => {
    return { 
      p_username: session.username,
      p_password: session.password,
      p_year: session.year
    }
  }, [session]);

  const handleSubmit = e => {
    e.preventDefault();
    let $this = e.currentTarget;

    if (!$this.checkValidity()) {
      $this.classList.add('was-validated');
      Helpers.form.isFormCorrect({ form: $this, toastr });
    } else {
      $this.classList.remove('was-validated');

      let button = $this.querySelector('button');
      let buttonHTML = button.innerHTML;
      button.innerHTML = Helpers.icon.spin();
      
      Controllers.user.get_login(dataSubmit()).then(res => {
        Helpers.toastr.construct({ response: res.response, message: res.message, toastr });
        if (res.response === 'success') {
          // Validar fortaleza de contraseña actual
          const strong = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,}$/.test(session.password)
          if (!strong) {
            setShowChangePwd(true)
            button.innerHTML = buttonHTML;
            return;
          }
          Helpers.localStorage.setSession({ jwt: res.data.jwt });
          window.location.href = Helpers.config.folder_path;
        } else {
          button.innerHTML = buttonHTML;
        }
      }).catch(req => {
        Helpers.promise.catch({req, toastr });
        button.innerHTML = buttonHTML;
      });
    }
  }

  const submitChangePassword = () => {
    if (changing) return;
    // Validaciones
    if (!newPwd || !confirmPwd) {
      Helpers.toastr.construct({ response: 'warning', message: 'Ingrese y confirme su nueva contraseña', toastr })
      return
    }
    if (newPwd !== confirmPwd) {
      Helpers.toastr.construct({ response: 'warning', message: 'La confirmación no coincide', toastr })
      return
    }
    const strong = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,}$/.test(newPwd)
    if (!strong) {
      Helpers.toastr.construct({ response: 'warning', message: 'La contraseña debe tener mínimo 8 caracteres, incluir letras, números y signos.', toastr })
      return
    }
    setChanging(true)
    Controllers.user.users_change_password_direct({ p_password: newPwd, p_username: session.username, p_year: session.year }).then(res => {
      Helpers.toastr.construct({ response: res.response, message: res.message, toastr })
      if (res.response === 'success') {
        setShowChangePwd(false)
        Helpers.localStorage.setSession({ jwt: res.data.jwt });
        window.location.href = Helpers.config.folder_path;
      }
    }).catch(req => {
      Helpers.promise.catch({ req, toastr })
    }).finally(() => setChanging(false))
  }

  return <div className={`bg-box ${isSigepro ? 'sigepro-login' : ''}`} style={{
    background: `url(${Helpers.config.api.images + '/dashboard/background-auth.png'})`,
    // background: `url(https://app.consultoriosanmarcos.org/assets/images/dashboard/background-auth.png)`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundPosition: 'center'
  }}>
    <div className="box-bg-container">
      <div className={`box-bg-content ${isSigepro ? 'sigepro-content' : 'bg-white'} form-row rounded`}>
        {isSigepro ? (
          <div className="col-12 d-flex align-items-center justify-content-center sigepro-header mb-4">
            {<img src={Helpers.config.api.images + '/logos/isotipo_logotipo.png'} alt={Helpers.config.company.name} className="sigepro-header-logo" />}
            {/* {<img src={'https://app.consultoriosanmarcos.org/assets/images/logos/isotipo_logotipo.png'} alt={Helpers.config.company.name} className="sigepro-header-logo" />} */}
            <div className="sigepro-header-title ml-3">
              <div className="sigepro-app">SIGEPRO</div>
              <div className="sigepro-sub">Sistema de Gestión de Procesos</div>
            </div>
          </div>
        ) : (
          <div className="col-12 text-center mb-4">
            <img src={Helpers.config.api.images + '/logos/isotipo_logotipo.png'} alt={Helpers.config.company.name} style={{
              maxHeight: '200px'
            }} />
          </div>
        )}

        <form onSubmit={handleSubmit} autoComplete="off" className="col-12 needs-validation" noValidate>
          <div className="form-row">
            <Input text="Nombre de usuario"
              placeholder="Nombre de usuario"
              icon="fa fa-user"
              classNameParent="col-12 mb-2"
              size={isSigepro ? 'lg' : 'sm'}
              required={true}
              defaultValue={session.username}
              onChange={e => setSession({ ...session, username: e.currentTarget.value })}
            />
            <Input type="password" 
              text="Contraseña"
              placeholder="Contraseña"
              icon="fa fa-lock"
              classNameParent="col-12 mb-2"
              size={isSigepro ? 'lg' : 'sm'}
              required={true}
              defaultValue={session.password}
              onChange={e => setSession({ ...session, password: e.currentTarget.value })}
            />
            <Select
              required
              text="Año"
              classNameParent="col-12 mb-2"
              size={isSigepro ? 'lg' : 'sm'}
              defaultValue={{ value: currentYear , label: currentYear }}
              options={years.sort((a, b) => {
                if (a > b) return -1
                return 1
              }).map(y => {
                return {
                  value: y, label: y
                }
              })}
              icon="fa fa-calendar"
              onChange={value => setSession({ ...session, year: value.value })}
            />
            <CheckBox text="Recordarme" defaultChecked={false} id="remember_me" />
            <div className="col-12 mt-2">
              <Button variant="primary" type="submit" size={isSigepro ? 'lg' : 'sm'} block>
                <i className="fa fa-check mr-2"></i> Iniciar Sesión
              </Button>
            </div>
          </div>
        </form>

      </div>
    </div>
    <Modal show={showChangePwd} onHide={() => {}} backdrop="static" centered>
      <Modal.Header>
        <Modal.Title as="div"><i className="fa fa-lock mr-2"></i>Cambiar contraseña</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>Su contraseña actual es débil. Debe asignar una contraseña fuerte:</p>
        {(() => {
          const hasLetter = /[A-Za-z]/.test(newPwd)
          const hasNumber = /\d/.test(newPwd)
          const hasSymbol = /[^A-Za-z0-9]/.test(newPwd)
          const hasLen = newPwd.length >= 8
          return (
            <ul style={{ listStyle: 'none', paddingLeft: 0 }}>
              <li><i className={`mr-2 fa ${hasLen ? 'fa-check text-success' : 'fa-times text-danger'}`}></i>Mínimo 8 caracteres</li>
              <li><i className={`mr-2 fa ${hasLetter ? 'fa-check text-success' : 'fa-times text-danger'}`}></i>Al menos una letra</li>
              <li><i className={`mr-2 fa ${hasNumber ? 'fa-check text-success' : 'fa-times text-danger'}`}></i>Al menos un número</li>
              <li><i className={`mr-2 fa ${hasSymbol ? 'fa-check text-success' : 'fa-times text-danger'}`}></i>Al menos un signo</li>
            </ul>
          )
        })()}
        <div className="form-row">
          <Input type="password" text="Nueva contraseña" placeholder="Nueva contraseña" icon="fa fa-key" classNameParent="col-12 mb-2" required onChange={e => setNewPwd(e.currentTarget.value)} />
          <Input type="password" text="Confirmar contraseña" placeholder="Confirmar contraseña" icon="fa fa-key" classNameParent="col-12 mb-2" required onChange={e => setConfirmPwd(e.currentTarget.value)} />
          <div className="col-12 d-flex justify-content-end">
            <Button variant="success" size={isSigepro ? 'lg' : 'sm'} onClick={submitChangePassword} disabled={changing}>
              {changing ? <span dangerouslySetInnerHTML={{ __html: Helpers.icon.spin() }} /> : <><i className="fa fa-check mr-2"></i>Guardar</>}
            </Button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  </div>
}

export default Login;